import React from 'react';
import { FeatureGateTest } from '../components/FeatureGateTest';

export const FeatureTestPage: React.FC = () => {
  return (
    <div className="container mx-auto py-8">
      <h1 className="text-2xl font-bold mb-6">Feature Access Control Test Page</h1>
      <p className="mb-4 text-gray-600">
        This page helps test the feature gating system. It shows your current subscription status
        and demonstrates how different features are gated based on subscription tier.
      </p>
      <FeatureGateTest />
    </div>
  );
}; 